import './_news-page.scss';

(function newsPage() {
  const newsPageComponent: HTMLElement | null = document.querySelector('[data-component="news-page"]');
  if (newsPageComponent) {
    class NewsPage {
      public init() {
        const printButton = document.getElementById('informs-print-button');
        if (printButton) {
          printButton.addEventListener('click', () => {
            window.print();
          });
        }
      }
    }
    const page = new NewsPage();
    page.init();
  }
})();
